import { HttpInterceptorFn } from '@angular/common/http';
import { API_BASE_URL } from './api-config';
import { DEFAULT_LOCALE, SUPPORTED_LOCALES } from './locale.service';

/**
 * The backend owns every server-error text and localizes it by the request's `Accept-Language`, so every request to
 * the API carries the language currently selected in the console ('ar' or 'en'). Read per request, so a language
 * switch applies to the very next call. Requests to other origins (i18n files, third parties) are left alone.
 */
export const acceptLanguageInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.startsWith(API_BASE_URL) || req.headers.has('Accept-Language'))
    return next(req);
  // The language LocaleService.apply() put on <html lang>. Not TranslateService itself: its i18n loader goes through HttpClient, so
  // injecting it from an interceptor is a circular dependency (NG0200) that leaves the app blank.
  const current = document.documentElement.lang ?? '';
  const lang = (SUPPORTED_LOCALES as readonly string[]).includes(current)
    ? current
    : DEFAULT_LOCALE;
  return next(req.clone({ setHeaders: { 'Accept-Language': lang } }));
};
